import { useFormController } from '@dreryk/react-common';
import { AttachmentsQrCodeUrl, StyledFlex } from '@dreryk/react-components';

import {
   ConsentsAndAuthorizationsDocumentScannerFormBean,
   ConsentsAndAuthorizationsDocumentScannerFormController,
} from './ConsentsAndAuthorizationsDocumentScannerForm.types';
import { PatientConsentDocumentAttachmentField } from './fields/PatientConsentDocumentAttachmentField';

type ConsentsAndAuthorizationsDocumentScannerFormRenderProps = Pick<
   ConsentsAndAuthorizationsDocumentScannerFormController,
   'trigger' | 'formState'
>;

type ConsentsAndAuthorizationsDocumentScannerFormProps = {
   readonly children: (renderProps: ConsentsAndAuthorizationsDocumentScannerFormRenderProps) => JSX.Element;
   readonly consentDocumentId: number;
   readonly qrCodeUrl: AttachmentsQrCodeUrl;
};

export const ConsentsAndAuthorizationsDocumentScannerForm = (
   props: ConsentsAndAuthorizationsDocumentScannerFormProps
): JSX.Element => {
   const { register, trigger, formState, sync } = useFormController<ConsentsAndAuthorizationsDocumentScannerFormBean>({
      attachments: null,
   });

   return (
      <>
         <StyledFlex as={'form'} direction={'column'} gap={'24px'} noValidate>
            <PatientConsentDocumentAttachmentField
               controller={register('attachments', { required: true })}
               consentDocumentId={props.consentDocumentId}
               qrCodeUrl={props.qrCodeUrl}
               sync={sync}
            />
         </StyledFlex>
         {props.children({
            trigger: trigger,
            formState: formState,
         })}
      </>
   );
};
